import { Theme } from '@mui/material';

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useMenuItemStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      fontSize: '14px',
      marginBottom: theme.spacing(),
    },
    title: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: theme.spacing(),
      textTransform: 'uppercase',
    },
    icon: {
      width: '20px',
      height: '20px',
    },
    link: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      textDecoration: 'none',
      padding: `${theme.spacing()} ${theme.spacing()} 0 ${theme.spacing()}`,
      color: theme.customPalette.darkBlue,
      '&.active': {
        fontWeight: theme.fontWeight,
      },
      [theme.breakpoints.down('sm')]: {
        padding: `${theme.spacing()} ${theme.spacing()} 0 ${Number(theme.spacing().replace('px', '')) * 2}px`,
      },
    },
    counter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: theme.customPalette.red,
      color: theme.customPalette.white,
      fontSize: '10px',
      borderRadius: '20px',
      width: '20px',
      height: '20px',
      marginLeft: '5px',
    },
    button: {
      border: 'none',
      fontFamily: 'Montserrat, sans-serif',
      color: theme.customPalette.darkBlue,
      backgroundColor: 'transparent',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  })
);
